module.exports = __webpack_public_path__ + "c7d5f1850adabe836e314629c0151c03.png";